import { Injectable } from '@angular/core';
import { Constants, stringifyParamFilters } from '@sportlogiq/shared';
import { Observable } from 'rxjs';
import { CustomHttp } from '../custom-http.service';
import { EventsTimelineRequestParamsApi, EventsTimelineResponseApi, FlagEventDefinition, GameEventDefinition, PlayerEventDefinition, ShiftEventDefinition } from './event.models';

@Injectable()
export class EventService {
    constructor(private _http: CustomHttp) {}

    public getGameEventDefinitionsAPI(): Observable<GameEventDefinition[]> {
        return this._http.get(`/gameeventdefinitions`, undefined, Constants.api_root_v3);
    }

    public getPlayerEventDefinitionsAPI(): Observable<PlayerEventDefinition[]> {
        return this._http.get(`/playereventdefinitions`, undefined, Constants.api_root_v3);
    }

    public getFlagEventDefinitionsAPI(): Observable<FlagEventDefinition[]> {
        return this._http.get(`/flagdefinitions`, undefined, Constants.api_root_v3);
    }

    public getShiftEventDefinitionsAPI(): Observable<ShiftEventDefinition[]> {
        return this._http.get(`/definitions/playershiftevent`, undefined, Constants.api_root_v3);
    }

    public getEventsTimelineForVideo(
        videoId: string,
        params: EventsTimelineRequestParamsApi
    ): Observable<EventsTimelineResponseApi> {
        const queryParamString = stringifyParamFilters(params, true);
        return this._http.get(`/videos/${videoId}/eventstimeline${queryParamString}`, undefined, Constants.api_root_v3);
    }
}
